import React from 'react';
import './AppointmentReceipt.css';
import { dateTimeFormatter, dateTimeFormatter2 } from '../Utils/DateTimeFormatter';

const AppointmentReceipt = React.forwardRef(({ invoice, patient }, ref) => {
    if (!invoice) return null;

    const patientObj = patient || {};
    const {
        invoiceId,
        invoiceTime,
        invoiceName,
        invoiceDescription,
        totalAmount = 0,
        amountPaid = 0,
        payments = [],
        createdBy,
        printedBy,
    } = invoice;

    const balance = (totalAmount || 0) - (amountPaid || 0);

    return (
        <div className="receipt-container" ref={ref}>
            {/* Header */}
            <div className="receipt-header">
                <img src="/VThospitalsLogo.png" alt="Logo" className="logo" />
                <h2 className="clinic-name">VISWATEJA HOSPITAL & DIAGNOSTIC CENTRE</h2>
                <p className="clinic-address">26-4-788/1, RPGT Road, Near Srinivasa Talkies, Hindupur - 515201</p>
            </div>

            {/* Patient & Appointment Info */}
            <table className="info-table">
                <tbody>
                    <tr>
                        <td style={{ width: '15%' }}>Patient Name:</td>
                        <td style={{ width: '35%' }}><strong>{patientObj.patientName || 'N/A'}</strong></td>
                        <td style={{ width: '15%' }}>MR No:</td>
                        <td style={{ width: '35%' }}><strong>{patientObj.mrNumber || 'N/A'}</strong></td>
                    </tr>
                    <tr>
                        <td>Age/Gender:</td>
                        <td><strong>{(patientObj.age || patientObj.ageYears || 'N/A')} / {patientObj.gender || 'N/A'}</strong></td>
                        <td>Phone:</td>
                        <td>{patientObj.phoneNumber || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td>Doctor:</td>
                        <td>{patientObj.doctorName || 'N/A'}</td>
                        <td>Appointment Date:</td>
                        <td>{dateTimeFormatter(patientObj.appointmentDate, patientObj.timeSlot)}</td>
                    </tr>
                    <tr>
                        <td>Invoice No:</td>
                        <td><strong>{invoiceId || 'N/A'}</strong></td>
                        <td>Token No:</td>
                        <td><strong>{patientObj.tokenNumber || 'N/A'}</strong></td>
                    </tr>
                </tbody>
            </table>

            {/* Particulars Items Table */}
            <table className="items-table">
                <thead>
                    <tr>
                        <th style={{ width: '30%' }}>Particulars</th>
                        <th style={{ width: '50%' }}>Description</th>
                        <th style={{ width: '20%', textAlign: 'right' }}>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{invoiceName || 'N/A'}</td>
                        <td>{invoiceDescription || 'N/A'}</td>
                        <td style={{ textAlign: 'right' }}>₹{(totalAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                    </tr>
                </tbody>
            </table>

            {/* Amount Summary */}
            <div className="amount-summary">
                <div><strong>Total Amount:</strong> ₹{(totalAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
                <div><strong>Paid Amount:</strong> ₹{(amountPaid || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
                <div><strong>Balance:</strong> ₹{(balance < 0 ? 0 : balance).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
            </div>

            {/* Payment Transactions Details */}
            <h3 className="section-heading">Payment Details</h3>
            <table className="receipt-details-table">
                <thead>
                    <tr>
                        <th style={{ width: '25%' }}>Payment ID</th>
                        <th style={{ width: '25%' }}>Date/Time</th>
                        <th style={{ width: '20%' }}>Transaction Type</th>
                        <th style={{ width: '15%' }}>Mode</th>
                        <th style={{ width: '15%', textAlign: 'right' }}>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {payments && payments.length > 0 ? (
                        payments.map((pmt, i) => (
                            <tr key={i}>
                                <td>{pmt.paymentId || 'N/A'}</td>
                                <td>{dateTimeFormatter2(pmt.paymentDate)}</td>
                                <td>{pmt.transactionType || 'PAYMENT'}</td>
                                <td>{pmt.paymentMode || 'CASH'}</td>
                                <td style={{ textAlign: 'right' }}>₹{(pmt.amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5" style={{ textAlign: 'center', color: '#64748b', fontStyle: 'italic' }}>
                                No payment transactions recorded
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {/* Invoice Master Record */}
            <h3 className="section-heading">Invoice Details</h3>
            <table className="receipt-details-table">
                <thead>
                    <tr>
                        <th style={{ width: '35%' }}>Invoice ID</th>
                        <th style={{ width: '40%' }}>Invoice Date/Time</th>
                        <th style={{ width: '25%', textAlign: 'right' }}>Invoice Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{invoiceId || 'N/A'}</td>
                        <td>{dateTimeFormatter2(invoiceTime)}</td>
                        <td style={{ textAlign: 'right' }}>₹{(totalAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                    </tr>
                </tbody>
            </table>

            {/* Footer */}
            <div className="footer-info">
                <span><strong>Printed By:</strong> {printedBy || "System"}</span>
                <span><strong>Created By:</strong> {createdBy || "Admin"}</span>
            </div>
        </div>
    );
});

export default AppointmentReceipt;
